import { Component } from '@angular/core';
import { BaseBPWizardFormComponent } from '../base-bp-wizard-form.component';
import { StateService, TransitionService } from '@uirouter/angular';
import { BPWizardService, IBPProfileData } from '../bp-wizard.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { BPProfilesDataService } from '../../bp-profiles-data.service';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { IBankFormChange } from '../../advanced/bank/bp-profiles-bank.component';
import * as _ from 'underscore';
import { util } from '../../../../shared/util';

@Component({
  selector: 'bp-wizard-bank',
  template: `
    <h2 [class.step-complete]="stepComplete"><text key="HEADING"></text></h2>
    <text key="BANKDETAILS"></text>
    
    <div class="d-block margin-top-sm">
      <bp-profiles-bank [editingMode]="true" [saveFn]="save" (onBankFormChange)="onBankFormChange($event)"></bp-profiles-bank>  
    </div>
  `
})
export class BPWizardBankComponent extends BaseBPWizardFormComponent {
  private selectedTab:string;

  constructor(
    transitionService:TransitionService,
    bpWizardService:BPWizardService,
    bpProfilesService:BPProfilesService,
    bpProfilesDataService:BPProfilesDataService,
    validateService:GaValidateService,
    stateService:StateService
  ) {
    super(transitionService, bpWizardService, bpProfilesService, bpProfilesDataService, validateService, stateService);
  }

  public save = ():Promise<any> => {
    return this.onSave();
  };

  public onBankFormChange(data:IBankFormChange):void {
    this.form = data?.form;
    this.fields = data?.fields;
    this.selectedTab = data?.selectedTab;
    // cleanup model because formly will add null value to empty field value
    // this is to make sure behavior is correct when comparing between backup model and model for model change
    const model:IBPProfileData = _.extend(this.bpWizardService.model, data?.model);
    _.each(model[this.selectedTab], (val:any, key:string):void => {
      if (util.isNullOrUndefinedOrEmpty(val)) {
        delete model[this.selectedTab][key];
      }
    });
    this.bpWizardService.model = model;
    // update save button enabled
    this.bpWizardService.emitSaveButtonEnabled(this.isFormValuesChange);
  }
}